import { useEventCallback } from '@flippingbook/web.react-hooks/dist/useEventCallback';
import { createContext, useContext, useState } from 'react';

import { driftService } from '@/services/instance/drift';

import type { State, Context } from './types';

const DriftLoaderContext = createContext<Context | undefined>(undefined);

export function DriftLoaderProvider({ providerKey, children }: { children: React.ReactNode; providerKey: string }) {
    const [state, setState] = useState<State>('initial');

    const value = {
        providerKey,
        state,
        setState,
    };

    return (
        <DriftLoaderContext.Provider value={value}>
            <link
                rel="preconnect"
                href="https://js.driftt.com"
                crossOrigin=""
            />
            {children}
        </DriftLoaderContext.Provider>
    );
}

export const useDriftLoader = () => {
    const ctx = useContext(DriftLoaderContext);

    if (ctx == null) {
        throw new Error('useDriftLoader must be used inside a DriftLoaderProvider.');
    }

    const { providerKey, state, setState } = ctx;

    const openChat = useEventCallback(async () => {
        if (state === 'initial') {
            setState('loading');
            await driftService.load(providerKey);
            setState('complete');
        }
        driftService.openChat();
    });

    return [state, openChat] as const;
};
